import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { Tag } from 'lucide-react'
import Icon from 'components/_UI/Icon'
import ProfileMenu from 'components/commons/ProfileMenu'
import NotificationBell from 'components/commons/NotificationBell'
import { useUser } from 'context/user/User'
import ROLES from 'helpers/roles'
import paths from 'routes/paths'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import indexPriority from 'theme/z-index'

export default function Topbar() {
    const navigate = useNavigate()
    const { user } = useUser()

    const [visibleDropdown, setVisibleDropdown] = useState(false)

    const isEstablishmentRole = user?.role?.id == ROLES.ESTABLISHMENT || user?.role?.id == ROLES.ADMIN
    const showTicketsLink = !isEstablishmentRole && user?.role?.id != ROLES.PRODUCER

    return (
        <StyledHeader onClick={() => setVisibleDropdown(false)}>
            <WhizrLogo href={paths.home}>
                <Icon name={'whizr-inline-logo-dark'} />
            </WhizrLogo>

            <RightNavContainer>
                {
                    showTicketsLink && (
                        <HeaderLink onClick={() => navigate(paths.user.wallet)}>
                            <Tag size={15} />
                            <span>Meus ingressos</span>
                        </HeaderLink>
                    )
                }

                <NotificationBell />

                <ProfileMenu
                    isOpen={visibleDropdown}
                    onOpenChange={setVisibleDropdown}
                />
            </RightNavContainer>
        </StyledHeader>
    )
}

const StyledHeader = styled.header`
    display: flex;
    flex-direction: row;
    padding: 10px 16px;
    justify-content: space-between;
    align-items: center;
    background: ${colors.neutralBackground};
    position: sticky;
    top: 0;
    width: 100%;
    z-index: ${indexPriority.tremendous};
    box-shadow: 1px 1px 4px #ddd;

    @media screen and (min-width: ${breakpoints.lg}) {
        padding: 20px;
    }

    @media screen and (min-width: 1400px) {
        padding: 20px 40px;
    }
`;

const WhizrLogo = styled.a`
    width: 100px;
    height: 30px;
    cursor: pointer;
    transition: all ease-in-out .25s;
    flex-shrink: 0;

    &:hover {
        opacity: 0.85;
    }
`;

const RightNavContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: auto;

    @media screen and (min-width: 1400px) {
        gap: 24px;
    }
`;

const HeaderLink = styled.div`
    display: none;
    align-items: center;
    gap: 6px;
    color: #717680;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    transition: all 0.2s ease;

    @media screen and (min-width: ${breakpoints.lg}) {
        display: flex;
    }

    &:hover {
        color: #4a4d54;
    }
`;
